import { Dispatch } from 'redux';
import { apiErrorClear } from '../../../../global/ducks/base-api';
import { patchTermination } from '../../../../global/ducks/person-prc-api';
import { formatDate } from '../../../../global/helpers/form-data-helper';
import { removeNonStipEmployment, removeStipEmployment } from '../employment/employment-slice';
import { EmploymentCombinationTypes, TerminationFormValues } from './models/termination-form-model';

function updateEmploymentState(dispatch: Dispatch<any>, stipTerminated?: boolean, nonStipTerminated?: boolean) {
	if (stipTerminated) {
		dispatch(removeStipEmployment());
	}

	if (nonStipTerminated) {
		dispatch(removeNonStipEmployment());
	}
}

export function terminateEmployeeRequest(
	dispatch: Dispatch<any>,
	employeeId: string,
	stipEmploymentId: number,
	nonStipEmploymentId: number,
	values: TerminationFormValues,
	successCallback: (messages) => void,
	onFailure?: () => void) {

	dispatch(apiErrorClear());
	const promises = [];

	if (values?.employment_types?.includes(EmploymentCombinationTypes.NonStipendiary)) {
		promises.push(new Promise<string>(function (resolve, reject) {

			const payload = {
				termination_date: formatDate(values?.termination_date),
				person_retiring_indicator: values?.person_retiring_indicator,
				employment_type: EmploymentCombinationTypes.NonStipendiary,
				termination_type: values?.termination_type,
				extenuating_circumstances: values?.extenuating_circumstances,
				employment_id: nonStipEmploymentId?.toString(),
			};

			const keys = Object.keys(payload);
			keys.forEach(a => {
				if (!payload[a]) {
					delete payload[a];
				}
			});


			dispatch(patchTermination(
				payload,
				employeeId,
				(r) => {
					resolve(r?.status?.message);
				},
				() => {

					reject();
				},
			));


		}));

	}


	if (values?.employment_types.includes(EmploymentCombinationTypes.Stipendiary)) {
		promises.push(new Promise<string>(function (resolve, reject) {

			const payload = {
				termination_date: formatDate(values?.termination_date),
				person_retiring_indicator: values?.person_retiring_indicator,
				employment_type: EmploymentCombinationTypes.Stipendiary,
				termination_type: values?.termination_type,
				extenuating_circumstances: values?.extenuating_circumstances,
				employment_id: stipEmploymentId?.toString(),
			};

			const keys = Object.keys(payload);
			keys.forEach(a => {
				if (!payload[a]) {
					delete payload[a];
				}
			});

			dispatch(patchTermination(
				payload,
				employeeId,
				(r) => {
					resolve(r?.status?.message);
				},
				() => {

					reject();
				},
			));


		}));
	}

	Promise.all(promises).then((messages: string[]) => {
		successCallback(messages);				
		if (values?.employment_types?.includes(EmploymentCombinationTypes.NonStipendiary)) {
			updateEmploymentState(dispatch, false, true);
		}
		if (values?.employment_types?.includes(EmploymentCombinationTypes.Stipendiary)) {

			updateEmploymentState(dispatch, true, false);
		}
	}).catch(()=>{
		if (onFailure){
			onFailure();
		}
	});
}

export function employeeDeathRequest(
	dispatch: Dispatch<any>,
	employeeId: string,
	values: TerminationFormValues,
	successCallback: () => void) {

	dispatch(apiErrorClear());

	const payload = {
		termination_date: formatDate(values?.termination_date),
		termination_type: values?.termination_type,
	};

	dispatch(patchTermination(
		payload,
		employeeId,
		() => {
			updateEmploymentState(dispatch, false, true);
			successCallback();
		},
		null,
	));


}

export function personNeverWorkedHereRequest(
	dispatch: Dispatch<any>,
	employeeId: string,
	stipEmploymentId: number,
	nonStipEmploymentId: number,
	values: TerminationFormValues,

	successCallback: (messages) => void) {

	dispatch(apiErrorClear());

	const promises = [];

	if (stipEmploymentId) {

		const payload = {
			termination_date: formatDate(values?.termination_date),
			termination_type: values?.termination_type,
			employment_type: EmploymentCombinationTypes.Stipendiary,
			employment_id: stipEmploymentId?.toString(),
		};

		promises.push(new Promise<void>(function (resolve, reject) {
			dispatch(patchTermination(
				payload,
				employeeId,
				() => {
					// success
					resolve();
				}, () => {
					// fail
					reject();
				},
			));
		}));
	}

	if (nonStipEmploymentId) {

		const payload = {
			termination_date: formatDate(values?.termination_date),
			termination_type: values?.termination_type,
			employment_type: EmploymentCombinationTypes.NonStipendiary,
			employment_id: nonStipEmploymentId?.toString(),
		};

		promises.push(new Promise<void>(function (resolve, reject) {
			dispatch(patchTermination(
				payload,
				employeeId,
				() => {
					// success
					resolve();
				}, () => {
					// delete failed
					reject();
				},
			));
		}));
	}

	Promise.all(promises).then((messages: string[]) => {
		// all requests successful
		successCallback(messages);
		if (nonStipEmploymentId) {

			updateEmploymentState(dispatch, false, true);
		}
		if (stipEmploymentId) {

			updateEmploymentState(dispatch, true, false);
		}
	});
}